import { Injectable } from '@angular/core';

@Injectable()
export class DatabaseService {

  title = "Laboratorio de Juegos";
  year = 2018;

  collections: any = [
      {     
          id: 0,
          slug: 'flora-y-fauna',
          projects: [
              {
                id: 0,
                slug: 'flor-de-taxo-raposa-y-colibri',
                detailURL: 'https://vortixhead.com/ldj360/1RaposaFlorTaxoColibri/Instalacion%20Raposa%20Flor%20de%20Taxo%20y%20Colibri%20%202_XR.451.html',
                color: 'FFFF00',
                bgColor: '00275A',
                description: 'En esta instalación quisimos plasmar la idea de energía, abundancia, movimiento y temporalidad, y por ello optamos por estos tres elementos de la flora y fauna, con mucho peso simbólico no solo en la sierra de Ecuador, sino en varias partes de América.',
                has360: true
              },
              { 
                id: 1,
                slug: 'juegos-inclusivos-la-flora',
                detailURL: 'https://vortixhead.com/ldj360/1RaposaFlorTaxoColibri/Instalacion%20Raposa%20Flor%20de%20Taxo%20y%20Colibri%20%202_XR.451.html',
                color: '0036FF',
                bgColor: '006837',
                description: 'En esta instalación nos centramos en la idea de la inclusión e interacción. En cada juego interactúan personas desde los 5 años en adelante, sin importar condición física o diversidad funcional. Son juegos que buscan la contención, por un lado, la armonía, por otro, y la igualdad. Se da una dinámica entre lo grupal y lo autónomo, siempre tomando en cuenta el respeto a las diferencias.',
                has360: false
              },
              {
                id: 2,
                slug: 'aves',
                detailURL: 'https://vortixhead.com/ldj360/1RaposaFlorTaxoColibri/Instalacion%20Raposa%20Flor%20de%20Taxo%20y%20Colibri%20%202_XR.451.html',
                color: '9F00FF',
                bgColor: 'E06F1D',
                description: 'Esta colección está compuesta por juegos tradicionales alrededor de la imagen de las aves. Es una celebración de nuestra identidad latinoamericana, que “vuela”, se moviliza de una región a otra.',
                has360: false
              },
              {
                id: 3,
                slug: 'anfibios',
                detailURL: 'https://vortixhead.com/ldj360/1RaposaFlorTaxoColibri/Instalacion%20Raposa%20Flor%20de%20Taxo%20y%20Colibri%20%202_XR.451.html',
                color: '96C314',
                bgColor: '1EB2F0',
                description: 'La agilidad, el cambio y la adaptabilidad es lo que se buscó reflejar en esta instalación, a través de las figuras de los anfibios, los cuales simbolizan la transformación, la metamorfosis, el renacimiento o florecimiento, la ligereza y vivacidad. ',
                has360: false
              },
              {
                id: 4,
                slug: 'redes-de-tela-arana',
                detailURL: 'https://vortixhead.com/ldj360/1RaposaFlorTaxoColibri/Instalacion%20Raposa%20Flor%20de%20Taxo%20y%20Colibri%20%202_XR.451.html',
                color: '00E3FF',
                bgColor: '951372',
                description: 'Las telarañas son obras arquitectónicas majestuosas. Su perfección, proporcionalidad y resistencia sirvieron como estímulo para esta instalación. Las redes parten en un punto y luego se irradian y unifican, se consolidan, pero mantienen siempre su geometría y movilidad.',
                has360: false
              },
          ]
      },
      {
          id: 1,
          slug: 'zoom',
          projects: [
            {
              id: 0,
              slug: 'manglar',
              detailURL: 'https://vortixhead.com/ldj360/1RaposaFlorTaxoColibri/Instalacion%20Raposa%20Flor%20de%20Taxo%20y%20Colibri%20%202_XR.451.html',
              color: 'FBB03B',
              bgColor: '26259E',
              description: 'Esa instalación se inspiró en la idea del manglar como ecosistema: un conjunto de elementos y procesos que, al conectarse, generan una dinámica en cadena. La instalación fue diseñada en módulos que interactúan entre sí como un todo, sin dejar de ser multifuncionales, tal como sucede con los elementos de un manglar.'
            }
        ]
      },
      {
          id: 2,
          slug: 'formas-y-curvas',
          projects: [
            {
              id: 0,
              slug: 'juegos-basicos',
              detailURL: 'https://vortixhead.com/ldj360/1RaposaFlorTaxoColibri/Instalacion%20Raposa%20Flor%20de%20Taxo%20y%20Colibri%20%202_XR.451.html',
              color: '00FF00',
              bgColor: '50126B',
              description: 'Cuando empezamos a armar un diseño, observamos los detalles de la cotidianidad. Vamos de lo macro a lo micro. Buscamos la belleza en lo sencillo, y la riqueza de las fusiones.'
            }
        ]
      }
  ]

  homeSliders = [
    'home1.jpg',
    'home2.jpg',
    'home3.jpg'
  ]

  

  constructor() { }

}



// WEBPACK FOOTER //
// ./src/app/database.service.ts